module.exports = __webpack_public_path__ + "img/697.d21064bf.png";